import { render } from "./TypeClientPage.vue?vue&type=template&id=11cd1035&ts=true"
import script from "./TypeClientPage.vue?vue&type=script&lang=ts"
export * from "./TypeClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__